class ZipCodeVerify {
    static zipBtn;
    static zipField;
    static modalToggle;
    static errorArea;
    static zipFile;

    constructor(props) {
        this.zipBtn = document.getElementById('zipCodeBtn')
        this.zipField = document.getElementById('zipCode');
        this.modalToggle = document.getElementById('modal-toggle');
        this.errorArea = document.getElementById('errorMsg');

        this.init();
    }

    init() {
        if(this.zipField) {
            this.zipField.value = '';
            this.zipField.focus();

            this.zipField.addEventListener('keyup', ({key}) => {
                if(key === "Enter") {
                    this.verifyZipCode();
                }
            });
            this.zipBtn.addEventListener('click',  (e) => {
                e.preventDefault();

                this.verifyZipCode();
            });
        }
    }


    verifyZipCode = () => {
        try {
            const zipCode = this.zipField.value;

            // Zip code validtaion
            const pattern = /(^\d{5}$)/;
            const zip = String(zipCode);
            const match = zip.match(pattern);

            if (zipCode.length < 1) {
                const er = new Error;
                const errorMsg = {
                    error: 'Please enter a zip code.',
                    data: zipCode
                };

                er.message = JSON.stringify(errorMsg);
                throw er;
            }

            if(!match) {
                const er = new Error;
                const errorMsg = {
                    error: 'Invalid zip code format.',
                    data: zipCode
                };

                er.message = JSON.stringify(errorMsg);
                throw er;
            }
            
            let wpURL = "/wp-admin/admin-ajax.php?action=zipcode";
            const postObj = { 
                data: {
                zipCode: zipCode || ''
                }
            }

            this.modalToggle.removeAttribute('checked');
            
            fetch(wpURL, {
                method: 'post',
                body: JSON.stringify(postObj),
                mode: 'cors',
                headers: new Headers({
                'Content-Type': 'application/json'
                })
            })
            .then(response => response.json())
            .then(json => {
                if(json.success) {
                    // Set cookie
                    this.setCookie('fvb-zipcode', zipCode, 14);                    
                    this.zipField.value = '';
                } else {
                    const er = new Error;
                    er.message = JSON.stringify(json);
                    document.getElementById('modal-toggle').setAttribute("checked", true);

                    throw er;
                }
                
            })
            .catch((e) => {
                this.displayError(JSON.parse(e.message));
            });
        } catch(e) {
            console.log(e);
            this.displayError(JSON.parse(e.message));
        }
    }

    readCookie = (cname) => {
        const nameEQ = cname + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
           let c = ca[i];
           while (c.charAt(0) == ' ') c = c.substring(1, c.length);
           if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    setCookie = (cname, cvalue, exdays) => {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        const expires = "expires="+d.toUTCString();
        const samesite = "SameSite=Lax";
        document.cookie = cname + "=" + cvalue + "; " + expires + "; " + samesite;
    }

    displayError = (err) => {
        let msg = 'There\'s an error with the zip code you entered';
        if(err) {
            msg = err.error;
        } 
        this.errorArea.innerHTML = msg;
        this.zipField.focus();
    };
}

export default ZipCodeVerify;